/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Formulas_IntroInputs */

const en_gc_guides_formulas_intro = /** @type {(inputs: Gc_Guides_Formulas_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A formula turns a worksheet into something you can ask questions of. SUM answers “what is the total?” and IF lets a result change when a condition is met. Together they are a useful first exercise in the GridCraft spreadsheet editor, before you explore more advanced functions.`)
};

const zh_gc_guides_formulas_intro = /** @type {(inputs: Gc_Guides_Formulas_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公式让工作表能够回答问题。SUM 告诉你合计是多少，IF 则让结果根据条件改变。它们是熟悉 GridCraft 电子表格编辑器的实用起点，之后再探索更复杂的函数。`)
};

/**
* | output |
* | --- |
* | "A formula turns a worksheet into something you can ask questions of. SUM answers “what is the total?” and IF lets a result change when a condition is met. To..." |
*
* @param {Gc_Guides_Formulas_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_formulas_intro = /** @type {((inputs?: Gc_Guides_Formulas_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Formulas_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_formulas_intro(inputs)
	return zh_gc_guides_formulas_intro(inputs)
});
export { gc_guides_formulas_intro as "gc.guides.formulas.intro" }